import { render, staticRenderFns } from "./HandGraphic.vue?vue&type=template&id=4987515e&functional=true&"
import script from "./HandGraphic.vue?vue&type=script&lang=js&"
export * from "./HandGraphic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports